import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import { Grid } from "@mui/material";
import {
  Button,
  FileField,
  FileInput,
  TextInput,
  required,
  useNotify,
  useRefresh,
} from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import dataProvider from "server/dataProvider";
import { doctoralRequests } from "api/doctoralApi";
import { validateDateNotInFuture } from "utils/validations";

const CertificateDialog = ({ doctorantId, hasCertificate }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleConfirm = async data => {
    await dataProvider.customRequest(
      doctoralRequests.setDoctoralSchoolCertificate(doctorantId),
      { number: data.number, issuedOn: data.issuedOn, file: data.file },
      "POST",
      null,
      true,
    );
    notify("Сертификатът е записан успешно", { type: "success" });
    refresh();
  };

  return (
    <FormModal
      titleContent="Сертификат"
      saveTitle="Запази"
      dialogSize="md"
      onConfirm={handleConfirm}
      triggerButton={
        <Button
          label={hasCertificate ? "Промени сертификат" : "Добави сертификат"}
          startIcon={<WorkspacePremiumIcon />}
        />
      }
    >
      <Grid container spacing={2} sx={{ mt: 0 }}>
        <Grid item xs={12} md={6}>
          <TextInput
            source="number"
            label="Номер на сертификат"
            validate={required("Задължително")}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <CustomDateInput
            source="issuedOn"
            label="Дата на издаване"
            validate={[required("Задължително"), validateDateNotInFuture]}
            maxDate={new Date()}
            noTime
            fullWidth
            required
          />
        </Grid>
        <Grid item xs={12}>
          <FileInput
            source="file"
            label="Файл"
            accept={{ "application/pdf": [".pdf"], "image/*": [".png", ".jpg", ".jpeg"] }}
            validate={required("Задължително")}
          >
            <FileField source="src" title="title" />
          </FileInput>
        </Grid>
      </Grid>
    </FormModal>
  );
};

export default CertificateDialog;
